import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    HostBinding,
    inject,
    input,
    model
} from '@angular/core';
import {
    ControlValueAccessor,
    Validator,
    FormGroupDirective,
    AbstractControl,
    ValidationErrors,
    ControlContainer,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule
} from '@angular/forms';
import { Store } from '@ngxs/store';
import { ZSelectComponent } from '@shared/components/form-components/z-select/z-select.component';
import { ZFloatLabelComponent } from '../../../../../shared/components/form-components/z-float-label/z-float-label.component';
import { ZBranchSelectComponent } from '@shared/components/bussiness-components/z-branch-select/z-branch-select.component';
import { ZDclProvidedServiceCategorySelectorComponent } from '../z-dcl-provided-service-category-selector/z-dcl-provided-service-category-selector.component';

@Component({
    selector: 'z-dcl-off-site-provided-service-selector',
    imports: [
        ZSelectComponent,
        FormsModule,
        ReactiveFormsModule,
        ZFloatLabelComponent,
        ZBranchSelectComponent,
        ZDclProvidedServiceCategorySelectorComponent
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(
                () => ZDclOffSiteProvidedServiceSelectorComponent
            ),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZDclOffSiteProvidedServiceSelectorComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective //FormGroupDirective,
        }
    ],
    templateUrl: './z-dcl-offSite-provided-service-selector.component.html',
    styleUrl: './z-dcl-offSite-provided-service-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZDclOffSiteProvidedServiceSelectorComponent
    implements ControlValueAccessor, Validator
{
    @HostBinding('class') class?: string = 'flex grow flex-col gap-5';
    // @HostBinding('style') style?: string = 'flex-basis: 350px';

    protected rootFormGroup = inject(FormGroupDirective);

    label = input<string | undefined>('Παροχή Υπηρεσιών Εκτός Εγκατάστασης');
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('_id');
    options = model<IOffsiteProvidedServiceOption[] | undefined>(undefined);
    placeholder = input<string | undefined>(undefined);
    inputStyle = input<
        | {
              [klass: string]: any;
          }
        | null
        | undefined
    >(undefined);

    store = inject(Store);

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled: boolean = false;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        this.loadData();
        this.rootFormGroup.form.controls;
    }

    loadData() {
        // const  kk: InvoiceType;
        // kk.Payments?.[0]?.Type

        // https://aade.gr/sites/default/files/2024-12/myDATA%20API%20Documentation%20v1%20.0.10_official_erp.pdf
        this.options.set([
            {
                _id: 1,
                Type: '1',
                Title: 'Μετακίνηση σε συνεργαζόμενη οντότητα'
            } as IOffsiteProvidedServiceOption,
            {
                _id: 2,
                Type: '2',
                Title: 'Μετακίνηση εντός της ίδιας οντοτήτας' //Title: 'Μετακίνηση σε εγκατάσταση εντός της ίδιας οντοτήτας'
            } as IOffsiteProvidedServiceOption
        ]);
    }
}

export class IOffsiteProvidedServiceOption {
    _id?: number;
    Type?: string;
    Title?: string;
}
